import React from 'react';
import ElasticComponentContext from '../ElasticComponent/ElasticComponentContext';

const useIsRevision = () => {
  const { queryParams } = React.useContext(ElasticComponentContext);
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  // "/search" is a pre-defined path for search page no matter the language.
  const pathKey = window.location.pathname?.replace('/search', '');
  const [lastFirstLoadPathKey, setLastFirstLoadPathKey] = React.useState(pathKey);

  React.useEffect(() => {
    if (lastFirstLoadPathKey === pathKey) return;

    setIsFirstLoad(true);
    setLastFirstLoadPathKey(pathKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathKey]);

  React.useEffect(() => {
    if (!isFirstLoad) return;
    if (!queryParams?.q) return;

    setIsFirstLoad(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams?.q]);

  const getIsRevision = React.useMemo(() => {
    if (isFirstLoad) return false;

    return !!queryParams?.q;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams?.q]);

  return getIsRevision ? 'yes' : 'no';
};

export default useIsRevision;
